module.exports = __webpack_public_path__ + "static/media/about-2.72e84d7d.png";